import { render, staticRenderFns } from "./account-number.vue?vue&type=template&id=01d5a4d3"
import script from "./account-number.vue?vue&type=script&lang=ts"
export * from "./account-number.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports